import type { Location } from 'history';
import { getConsentIDs } from '@peloton/analytics/analytics';
import * as Analytics from '@peloton/analytics/analytics';
import type { TrackTraits } from '@peloton/analytics/types';

const DEFAULT_SOURCE = 'Direct Link';

export const identify = (
  {
    id,
    linkedSocialAccount,
    wodExperimentVariant,
    isTester,
    isEmployee,
    email,
  }: IdentityTraits,
  analytics = Analytics,
) => {
  setTimeout(() => {
    analytics.identify({
      userId: id,
      properties: {
        linkedSocialAccount,
        wodExperimentVariant,
        // User-level properties required for Segment/Amplitude chart filters.
        'Is Tester': isTester ?? false,
        'Is Employee': isEmployee ?? false,
        ...(email ? { Email: email } : {}),
        ...getConsentIDs({}),
      },
    });
  }, 1000);
};

export const track = <T extends object>(event: TrackTraits<T>, analytics = Analytics) => {
  analytics.track(event);
};

export const toSource = (location: Location) => location?.state?.source ?? DEFAULT_SOURCE;

export const toFeatureModule = (location: Location) =>
  location?.state?.['Featured Module'] ?? DEFAULT_SOURCE;

export const toRank = (location: Location) => location?.state?.Rank ?? DEFAULT_SOURCE;

export const toTotal = (location: Location) =>
  location?.state?.['Featured Total Classes'] ?? DEFAULT_SOURCE;

type IdentityTraits = {
  id: string;
  linkedSocialAccount?: string | null;
  wodExperimentVariant?: string | null;
  /** Amplitude user properties used by Segment chart filters. */
  isTester?: boolean;
  isEmployee?: boolean;
  email?: string;
};
